import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M13 4.75H11.25V3.5C11.25 2.63805 10.9076 1.8114 10.2981 1.2019C9.6886 0.59241 8.86195 0.25 8 0.25C7.13805 0.25 6.3114 0.59241 5.7019 1.2019C5.09241 1.8114 4.75 2.63805 4.75 3.5V4.75H3C2.66848 4.75 2.35054 4.8817 2.11612 5.11612C1.8817 5.35054 1.75 5.66848 1.75 6V13C1.75 13.3315 1.8817 13.6495 2.11612 13.8839C2.35054 14.1183 2.66848 14.25 3 14.25H13C13.3315 14.25 13.6495 14.1183 13.8839 13.8839C14.1183 13.6495 14.25 13.3315 14.25 13V6C14.25 5.66848 14.1183 5.35054 13.8839 5.11612C13.6495 4.8817 13.3315 4.75 13 4.75ZM6.25 3.5C6.25 3.03587 6.43437 2.59075 6.76256 2.26256C7.09075 1.93437 7.53587 1.75 8 1.75C8.46413 1.75 8.90925 1.93437 9.23744 2.26256C9.56563 2.59075 9.75 3.03587 9.75 3.5V4.75H6.25V3.5ZM12.75 12.75H3.25V6.25H12.75V12.75Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconLock'

export const IconLock = memo(themed(Icon))
